import { YAxis, YAxisProps } from "recharts";
import { Props } from "recharts/types/cartesian/YAxis";
import { AxisInterval } from "recharts/types/util/types";

import { CustomYAxisTick } from "@/utils/recharts-widgets";

type BarYAxisProps = {
  yTicksPaddingRight?: number;
  yTicksFormatter?: (value?: string | number) => string;
  axisTickColor?: string;
  yAxisWidth?: number;
  ticks?: number[];
  yAxisInterval?: AxisInterval;
  showYAxisLine?: boolean;
  yPaddingTop?: number;
  yPaddingBottom?: number;
  hideAxis?: boolean;
  yId?: "left" | "right";
} & YAxisProps;

const BarYAxis = ({
  yTicksPaddingRight,
  yTicksFormatter,
  axisTickColor,
  yAxisWidth,
  ticks,
  yAxisInterval,
  showYAxisLine,
  yPaddingTop,
  yPaddingBottom,
  hideAxis = false,
  yId,
  ...rest
}: BarYAxisProps) => {
  return (
    <YAxis
      {...rest}
      tick={(props: Props) => (
        <CustomYAxisTick
          {...{
            props,
            yTicksPaddingRight,
            yTicksFormatter,
            axisTickColor,
          }}
        />
      )}
      width={yAxisWidth}
      ticks={!ticks || ticks.length === 0 ? undefined : ticks}
      tickLine={false}
      interval={yAxisInterval}
      axisLine={showYAxisLine}
      padding={{ top: yPaddingTop, bottom: yPaddingBottom }}
      yAxisId={yId}
      orientation={yId}
      hide={hideAxis}
    />
  );
};

export default BarYAxis;
